import { useKeenSlider } from "keen-slider/react";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { teamImg1 } from "../../assets/img";
import "./BlogSlider.css";

function BlogSlider() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [loaded, setLoaded] = useState(false);
  const [sliderRef, instanceRef] = useKeenSlider({
    breakpoints: {
      "(min-width: 768px)": {
        slides: { perView: 2, spacing: 15 },
      },
      "(min-width: 1024px)": {
        slides: { perView: 2, spacing: 15 },
      },
    },

    slides: {
      perView: 1,
      spacing: 15,
    },
    slideChanged(slider) {
      setCurrentSlide(slider.track.details.rel);
    },
    created() {
      setLoaded(true);
    },
  });

  return (
    <section className="blogSlider_wrap spacing">
      <div className="container">
        {loaded && instanceRef.current && (
          <div className="navigation ">
            <button
              onClick={(e) =>
                e.stopPropagation() || instanceRef.current?.prev()
              }
              className={`s_nav_btn left ${
                currentSlide === 0 ? "--disabled" : ""
              }`}
              type="button"
            >
              <svg
                className="sc-ee2b2fa4-7 sc-ee2b2fa4-8 bYcxfr iHDuws"
                viewBox="0 0 34.197 34.192"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g fill="none" stroke="currentColor" strokeWidth="3">
                  <path d="M0 16.983h31.758" strokeLinejoin="round"></path>
                  <path d="m14.879 1.096 17.121 16-17.121 16"></path>
                </g>
              </svg>
            </button>
            <button
              onClick={(e) =>
                e.stopPropagation() || instanceRef.current?.next()
              }
              className={`s_nav_btn right ${
                currentSlide ===
                instanceRef.current.track.details.slides.length - 2
                  ? "--disabled"
                  : ""
              }`}
              type="button"
            >
              <svg
                className="sc-ee2b2fa4-7 bYcxfr"
                viewBox="0 0 34.197 34.192"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g fill="none" stroke="currentColor" strokeWidth="3">
                  <path d="M0 16.983h31.758" strokeLinejoin="round"></path>
                  <path d="m14.879 1.096 17.121 16-17.121 16"></path>
                </g>
              </svg>
            </button>
          </div>
        )}
      </div>
      <div className="bs-inner container">
        <div className={`title ${currentSlide > 0 ? "hide" : ""} `}>
          <h2>Blog+</h2>
          <h2 className="cambon_font">Find</h2>
        </div>
        <div className="bSlider">
          <div className="inner keen-slider " ref={sliderRef}>
            <div className="t-item keen-slider__slide">
              <div className="img-wrap">
                <img src={teamImg1} alt="" />
                <div className="content">
                  <div className="tags">
                    <h6>Technology</h6> <h6>ReactJs</h6>
                  </div>
                  <div className="b_title ">
                    <h4>React Hooks </h4>
                  </div>
                  <div className="date">
                    <h6>26.01.2023</h6>
                  </div>
                </div>
                <div className="overlay"></div>
              </div>
            </div>
            <div className="t-item keen-slider__slide">
              <div className="img-wrap">
                <img src={teamImg1} alt="" />
                <div className="content">
                  <div className="tags">
                    <h6>Technology</h6> <h6>ReactJs</h6>
                  </div>
                  <div className="b_title ">
                    <h4>React Hooks </h4>
                  </div>
                  <div className="date">
                    <h6>26.01.2023</h6>
                  </div>
                </div>
                <div className="overlay"></div>
              </div>
            </div>
            <div className="t-item keen-slider__slide">
              <div className="img-wrap">
                <img src={teamImg1} alt="" />
                <div className="content">
                  <div className="tags">
                    <h6>Technology</h6> <h6>ReactJs</h6>
                  </div>
                  <div className="b_title ">
                    <h4>React Hooks </h4>
                  </div>
                  <div className="date">
                    <h6>26.01.2023</h6>
                  </div>
                </div>
                <div className="overlay"></div>
              </div>
            </div>
            <div className="t-item keen-slider__slide">
              <div className="img-wrap">
                <img src={teamImg1} alt="" />
                <div className="content">
                  <div className="tags">
                    <h6>Technology</h6> <h6>ReactJs</h6>
                  </div>
                  <div className="b_title ">
                    <h4>React Hooks </h4>
                  </div>
                  <div className="date">
                    <h6>26.01.2023</h6>
                  </div>
                </div>
                <div className="overlay"></div>
              </div>
            </div>
            <div className="t-item keen-slider__slide">
              <div className="img-wrap">
                <img src={teamImg1} alt="" />
                <div className="content">
                  <div className="tags">
                    <h6>Technology</h6> <h6>ReactJs</h6>
                  </div>
                  <div className="b_title ">
                    <h4>React Hooks </h4>
                  </div>
                  <div className="date">
                    <h6>26.01.2023</h6>
                  </div>
                </div>
                <div className="overlay"></div>
              </div>
            </div>
            <div className="t-item keen-slider__slide">
              <div className="img-wrap">
                <img src={teamImg1} alt="" />
                <div className="content">
                  <div className="tags">
                    <h6>Technology</h6> <h6>ReactJs</h6>
                  </div>
                  <div className="b_title ">
                    <h4>React Hooks </h4>
                  </div>
                  <div className="date">
                    <h6>26.01.2023</h6>
                  </div>
                </div>
                <div className="overlay"></div>
              </div>
            </div>

            <div className="t-item keen-slider__slide">
              <div className="img-wrap">
                <img src={teamImg1} alt="" />
                <Link to="/magazine/reactJs" className="content">
                  <div className="tags">
                    <h6>Technology</h6> <h6>ReactJs</h6>
                  </div>
                  <div className="b_title ">
                    <h4>React Hooks </h4>
                  </div>
                  <div className="date">
                    <h6>26.01.2023</h6>
                  </div>
                </Link>
                <div className="overlay"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default BlogSlider;
